(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/shared-components/footer.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/shared-components/footer.js');

'use strict';

const {
  logger
} = svs.termsIntegrity;
const {
  ReactButton: Button
} = svs.ui;
const Footer = () => {
  const onCustomerServiceClick = () => {
    logger.debug('*** onButtonHelpClick');
    svs.utils.url.navigate(svs.core.urlMapping.get('customerServiceHome'), svs.core.urlMapping.get('startPage'));
  };
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "margin-xs-top-4 margin-bottom-0 align-center"
  }, "Beh\xF6ver du hj\xE4lp? Kontakta kundservice"), React.createElement("div", {
    className: "margin-xs-v-2 align-center"
  }, React.createElement(Button, {
    "aria-label": "L\xE4nk till kundservice",
    inverted: true,
    onClick: onCustomerServiceClick,
    role: "a",
    size: 300
  }, "Till kundservice")));
};
svs.termsIntegrity.sharedComponents.Footer = Footer;

 })(window);